/* Single-image mode: toggle stacked variant featured images on variant change. No fetch. */
(function () {
  "use strict";
  function activate(wrapper, mediaId) {
    var items = wrapper.querySelectorAll(".product__media-item[data-media-id]");
    var found = false;
    items.forEach(function (el) {
      var match = mediaId && el.dataset.mediaId.indexOf("-" + mediaId) > -1;
      if (match) found = true;
      el.classList.toggle("ga-media-hidden", !match);
    });
    if (!found && items.length) items[0].classList.remove("ga-media-hidden");
  }
  function init() {
    if (!document.querySelector("[data-ga-single-image]") || typeof subscribe !== "function") return;
    subscribe(PUB_SUB_EVENTS.variantChange, function (event) {
      var variant = event && event.data && event.data.variant;
      if (!variant) return;
      var mediaId = variant.featured_media && variant.featured_media.id;
      document.querySelectorAll("[data-ga-single-image]").forEach(function (w) { activate(w, mediaId); });
    });
  }
  document.readyState === "loading" ? document.addEventListener("DOMContentLoaded", init) : init();
})();
